import { render, staticRenderFns } from "./turnstile_manage.vue?vue&type=template&id=a27992ae&scoped=true"
import script from "./turnstile_manage.vue?vue&type=script&lang=js"
export * from "./turnstile_manage.vue?vue&type=script&lang=js"
import style0 from "./turnstile_manage.vue?vue&type=style&index=0&id=a27992ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27992ae",
  null
  
)

export default component.exports